<template>
  <div id="tool-tip">
    <img v-if="img" :src="img" :width="imgWidth" v-bind:class="imgPos"/>
    <p v-if="text && text.length > 0" v-bind:style="{color: textColor}">{{text}}</p>
    <div id="tool-tip-core" v-bind:class="posClass"  v-bind:style="{top: top + 'px', left: left + 'px', width: width}">
      <div v-if="message && message.length > 0">{{message}}</div>
      <div v-for="(arymessage,index) in messages" :key="'tooltip-msg-' + index">
        {{arymessage}}
      </div>
    </div>
 </div>
</template>
<script>

export default {
  name: 'ToolTip',
  props: {
    text: String,
    textColor: {
      default: '#000',
      type: String
    },
    img: String,
    imgWidth: {
      default: 'auto',
      type: String
    },
    message: String,
    messages: Array,
    posClass: {
      default: 'postop',
      type: String
    },
    top: {
      default: 0,
      type: Number
    },
    left: {
      default: 0,
      type: Number
    },
    width: {
      default: 'auto',
      type: String
    },
    imgPos: { // TODO DcProfitSettingの？マークの位置が共通化できなかった為、暫定で追加
      default: 'imgDef',
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
#tool-tip {
  margin: 5px;
  #tool-tip-core {
    display: none;
    z-index: 10000;
  }
  // img {
  //   width: 20px;
  //   vertical-align: middle;
  //   vertical-align: -webkit-baseline-middle;
  //   display: inline-block;
  // }
  p {
    display: inline-block;
    vertical-align: middle;
    vertical-align: -webkit-baseline-middle;
  }
}
.imgDef {
    width: 20px;
    vertical-align: middle;
    vertical-align: -webkit-baseline-middle;
    display: inline-block;
}

.imgTop {
  width: 20px;
  vertical-align: top;
  display: inline-block;
}

#tool-tip-core {
  font-weight: bold;
}
#tool-tip:hover {
  #tool-tip-core {
    display: inline-block;
  }
}

.postop {
  position: absolute;
  padding: 10px;
  font-size: 12px;
  line-height: 1.6em;
  color: #000;
  border-radius: 5px;
  background: #fff;
  border: 3px solid #ced4da;
  width: auto;
  word-break: keep-all;
  white-space: nowrap;
  &:before {
    content: "";
    position: absolute;
    bottom: -24px;
    left: 10%;
    margin-left: -15px;
    border: 12px solid transparent;
    border-top: 12px solid #FFF;
    z-index: 2;
  }
  &:after {
    content: "";
    position: absolute;
    bottom: -30px;
    left: 10%;
    margin-left: -17px;
    border: 14px solid transparent;
    border-top: 14px solid #ced4da;
    z-index: 1;
  }
}

// leftだけwidth指定が必須なので廃止
// .posleft {
//   position: absolute;
//   padding: 10px;
//   font-size: 12px;
//   line-height: 1.6em;
//   color: #000;
//   border-radius: 5px;
//   background: #fff;
//   border: 3px solid #FF4500;
//   width: auto;
//   word-break: keep-all;
//   &:before {
//     content: "";
//     position: absolute;
//     top: 50%;
//     right: -24px;
//     margin-top: -12px;
//     border: 12px solid transparent;
//     border-left: 12px solid #FFF;
//     z-index: 2;
//   }
//   &:after {
//     content: "";
//     position: absolute;
//     top: 50%;
//     right: -30px;
//     margin-top: -14px;
//     border: 14px solid transparent;
//     border-left: 14px solid #FF4500;
//     z-index: 1;
//   }
// }

.posright {
  position: absolute;
  padding: 10px;
  font-size: 12px;
  line-height: 1.6em;
  color: #000;
  border-radius: 5px;
  background: #fff;
  border: 3px solid #ced4da;
  width: auto;
  word-break: keep-all;
  white-space: nowrap;
  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: -24px;
    margin-top: -12px;
    border: 12px solid transparent;
    border-right: 12px solid #FFF;
    z-index: 2;
  }
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: -30px;
    margin-top: -14px;
    border: 14px solid transparent;
    border-right: 14px solid #ced4da;
    z-index: 1;
  }
}

.posbottom {
  position: absolute;
  padding: 10px;
  font-size: 12px;
  line-height: 1.6em;
  color: #000;
  border-radius: 5px;
  background: #fff;
  border: 3px solid #ced4da;
  width: auto;
  word-break: keep-all;
  white-space: nowrap;
  &:before {
    content: "";
    position: absolute;
    top: -24px;
    left: 10%;
    margin-left: -15px;
    border: 12px solid transparent;
    border-bottom: 12px solid #FFF;
    z-index: 2;
  }
  &:after {
    content: "";
    position: absolute;
    top: -30px;
    left: 10%;
    margin-left: -17px;
    border: 14px solid transparent;
    border-bottom: 14px solid #ced4da;
    z-index: 1;
  }
}

p {
  margin: 0 5px;
}

</style>



// WEBPACK FOOTER //
// src/main/js/components/common/ToolTip.vue